* {
  scrollbar-width: thin;
  scrollbar-color: black transparent;
}
